const CommentFilter = {
  new: function(){
    var object = Object.create(CommentFilter);
    object.bindAjaxSuccess();

    return object;
  },

  bindAjaxSuccess: function(){
    $('#dropdown-comment-newest-first').on('ajax:success', function(event){
      var data = event.detail[2].response;
      $('.comments__list').html(data);

      $(event.target).parents('.dropdown').find('.dropdown__selected').dropdown('toggle').html($(event.target).html());
      $('.comments__paginator-container').show();
      $("span.publish-date").timeago();

      var commentContainer = $('.comments__paginator-container').siblings('.comments__list');
      var last_comment_id = commentContainer.children().last().data('id');
      $('.comments__paginator-link').data('order', 'newest').data('last-comment-id', last_comment_id);
    });

    $('#dropdown-comment-top-comments').on('ajax:success', function(event){
      var data = event.detail[2].response;
      $('.comments__list').html(data);

      $(event.target).parents('.dropdown').find('.dropdown__selected').dropdown('toggle').html($(event.target).html());
      $('.comments__paginator-container').show();
      $("span.publish-date").timeago();
      $('.comments__paginator-link').data('order', 'like');
      $('.comments__paginator-link').data('offset', '3');
    });
  }
};

export default CommentFilter;
